import { Menu, MenuItem } from '@material-ui/core'
import CancelOrConfirmButton from 'presentation/hospital/components/AddTherapeuticPlanModal/CancelOrConfirmButton'
import Modal from 'presentation/hospital/components/Modal'
import SuccessModal from 'presentation/shared/components/Modal'

import Radio from 'presentation/shared/components/RadioButton'
import StatusChip from 'presentation/shared/components/StatusChip'
import TextArea from 'presentation/shared/components/TextArea'
import theme from 'presentation/styles/theme'
import React from 'react'
import { ReactComponent as MegaphoneIcon } from 'presentation/assets/icons/megaphone.svg'
import { ReactComponent as BellIcon } from 'presentation/assets/icons/bell.svg'
import * as S from './styles'
import { useServices } from 'presentation/hooks/use-services'
import { toast } from 'react-toastify'
import { ContactType } from 'domain/entities/ambulatory-contact-model'

type Props = {
  onClose: () => void
  patient_id?: number
  ambulatory_schedule_id?: number
}
export default function ContactRegistrationModal({
  onClose,
  patient_id,
  ambulatory_schedule_id
}: Props) {
  const [contact, setContact] = React.useState<boolean>()
  const [observation, setObservation] = React.useState<string>('')
  const [showSuccess, setShowSuccess] = React.useState<boolean>(false)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [checkedNotification, setCheckedNotification] = React.useState(false)
  const [status, setStatus] = React.useState<string>('Realizado')
  const [contactType, setContactType] = React.useState<ContactType>()
  const ambulatoryServices = useServices().ambulatory

  const chipContent = {
    Confirmado: {
      color: 'secondary'
    },
    Realizado: {
      color: 'golden'
    },
    Cancelado: {
      color: 'alert'
    }
  }

  const notificationContent = {
    false: {
      label: 'Enviar alerta ao paciente',
      icon: <MegaphoneIcon />
    },
    true: {
      label: 'Enviar confirmação ao paciente',
      icon: <BellIcon />
    }
  }

  const getModalTitle = () => {
    if (contact === true && status === 'Cancelado')
      return 'Agendamento cancelado com sucesso.'
    if (contact === true && status === 'Confirmado')
      return 'Agendamento confirmado com sucesso.'
    return 'Registro de contato realizado com sucesso.'
  }

  const onConfirm = async () => {
    try {
      if (contactType && patient_id && ambulatory_schedule_id) {
        await ambulatoryServices.ambulatoryContact(
          {
            contactType,
            isContacted: contact!,
            observation,
            sentNotification: checkedNotification
          },
          patient_id,
          ambulatory_schedule_id
        )
        setShowSuccess(true)
      }
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  return (
    <Modal close={onClose} bgColor={'white'}>
      <S.Container>
        <S.Title fontColor={'primary'} fontSize={'xlarge'}>
          Contato com paciente
        </S.Title>
        <S.Subtitle
          fontColor={'lightGray'}
          fontSize={'small'}
          style={{ marginBottom: '15px' }}
        >
          Notificação sobre nova tentativa de contato com o paciente.
        </S.Subtitle>
        <hr />
        <div style={{ marginTop: '20px' }}>
          <Radio
            showBackground={false}
            color="primary"
            customLabelComponent={
              <S.Subtitle
                fontColor={'lightGray'}
                fontSize={'small'}
                style={{ marginLeft: '22px' }}
              >
                Tentativa sem sucesso, pois não houve resposta
              </S.Subtitle>
            }
            checked={contact === false}
            onCheck={() => setContact(false)}
          />
          <Radio
            showBackground={false}
            color="primary"
            customLabelComponent={
              <S.Subtitle
                fontColor={'lightGray'}
                fontSize={'small'}
                style={{ marginLeft: '22px' }}
              >
                Contato bem sucedido
              </S.Subtitle>
            }
            checked={contact}
            onCheck={() => setContact(true)}
          />
          <S.Subtitle
            fontColor={'lightGray'}
            fontSize={'xsmall'}
            style={{ marginLeft: '60px', width: '90%' }}
            fontWeight="bold"
          >
            Em caso de contato bem sucedido, prossiga para alterar o status do
            paciente e deixar observações relevantes para acompanhamento
            subsequente.
          </S.Subtitle>
        </div>
        {contact !== undefined ? (
          <>
            <div
              style={{
                display: 'flex',
                gap: '61px',
                justifyContent: 'space-between'
              }}
            >
              <TextArea
                rows={4}
                placeholder={
                  !contact
                    ? 'Adicione informações como número inexistente ou chamada não atendida'
                    : ''
                }
                required
                bgColor="mainBg"
                style={{ width: '100%' }}
                value={observation || ''}
                onChange={(e) => setObservation(e.currentTarget.value)}
              />
              {contact ? (
                <div style={{ marginTop: '12px', cursor: 'pointer' }}>
                  <StatusChip
                    color={
                      chipContent[(status as keyof typeof chipContent) || '']
                        ?.color as keyof typeof theme.colors
                    }
                    label={`${status}`}
                    fontSize="small"
                    onClick={(e: any) => setAnchorEl(e.currentTarget)}
                  />
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                  >
                    <MenuItem
                      onClick={() => {
                        setStatus('Realizado')
                        setAnchorEl(null)
                      }}
                    >
                      Realizado
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setStatus('Cancelado')
                        setAnchorEl(null)
                      }}
                    >
                      Cancelado
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setStatus('Confirmado')
                        setAnchorEl(null)
                      }}
                    >
                      Confirmado
                    </MenuItem>
                  </Menu>
                </div>
              ) : null}
            </div>
            <div style={{ marginTop: '20px' }}>
              <S.Subtitle
                fontColor={'primary'}
                fontSize={'medium'}
                style={{ marginBottom: '15px' }}
              >
                Contato realizado através de
              </S.Subtitle>
              <div style={{ display: 'flex' }}>
                <Radio
                  showBackground={false}
                  color="primary"
                  customLabelComponent={
                    <S.Subtitle
                      fontColor={'lightGray'}
                      fontSize={'small'}
                      style={{ marginLeft: '22px' }}
                    >
                      WhatsApp
                    </S.Subtitle>
                  }
                  checked={contactType === 'WHATSAPP'}
                  onCheck={() => setContactType('WHATSAPP')}
                />
                <Radio
                  showBackground={false}
                  color="primary"
                  customLabelComponent={
                    <S.Subtitle
                      fontColor={'lightGray'}
                      fontSize={'small'}
                      style={{ marginLeft: '22px' }}
                    >
                      Telefone
                    </S.Subtitle>
                  }
                  checked={contactType === 'PHONE'}
                  onCheck={() => setContactType('PHONE')}
                />
                <Radio
                  showBackground={false}
                  color="primary"
                  customLabelComponent={
                    <S.Subtitle
                      fontColor={'lightGray'}
                      fontSize={'small'}
                      style={{ marginLeft: '22px' }}
                    >
                      E-mail
                    </S.Subtitle>
                  }
                  checked={contactType === 'EMAIL'}
                  onCheck={() => setContactType('EMAIL')}
                />
              </div>
              <S.WrapperContainer sendNotification={checkedNotification}>
                {
                  notificationContent[
                    String(contact) as keyof typeof notificationContent
                  ]?.icon
                }
                <S.Subtitle
                  fontColor={'lightGray'}
                  fontSize={'small'}
                  style={{
                    width: 'auto',
                    marginRight: '20px',
                    marginLeft: '20px'
                  }}
                >
                  {
                    notificationContent[
                      String(contact) as keyof typeof notificationContent
                    ]?.label
                  }
                </S.Subtitle>
                <S.UglySwitch
                  checked={checkedNotification}
                  onChange={() => setCheckedNotification(!checkedNotification)}
                />
              </S.WrapperContainer>
            </div>
          </>
        ) : null}
        <div style={{ marginTop: '50px' }}>
          <CancelOrConfirmButton
            cancelClick={() => onClose()}
            cancelText="Cancelar"
            confirmText="Concluir"
            confirmClick={onConfirm}
            confirmDisabled={
              contact === false ? !contactType : contact === undefined
            }
          />
        </div>
      </S.Container>
      <SuccessModal
        show={showSuccess}
        type={contact && status === 'Cancelado' ? 'alert' : 'check'}
        title={getModalTitle()}
        close={() => {
          setShowSuccess(false)
          onClose()
        }}
      />
    </Modal>
  )
}
